import { useMemo } from "react";
import { getDefaultTimezone } from "@/lib/timezones";

/**
 * Resolved default timezone for the current user.
 *
 * Order:
 *   1. localStorage["prism.user.timezone"] — set by the (planned)
 *      Account → Preferences page.
 *   2. `Intl.DateTimeFormat().resolvedOptions().timeZone` — whatever
 *      IANA zone the browser thinks it's in.
 *   3. "UTC" if neither is available.
 *
 * The value is memoised once per mount; localStorage doesn't change
 * reactively without a `storage` event from another tab, and the
 * browser's resolved timezone is stable for the page's lifetime, so
 * computing once is enough. If we later wire a "preferences updated"
 * dispatcher we'll subscribe here.
 *
 * Intended for *creation* forms — the field defaults to this value.
 * Update / edit forms should still seed from the saved object's
 * timezone first and only fall back to this when none was recorded.
 */
export function useDefaultTimezone(): string {
  return useMemo(() => getDefaultTimezone(), []);
}
